"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Breadcrumbs = _interopRequireDefault(require("@mui/material/Breadcrumbs"));
var _Breadcrumb = _interopRequireDefault(require("./Breadcrumb"));
var _Folder = _interopRequireDefault(require("@mui/icons-material/Folder"));
var _FolderOpen = _interopRequireDefault(require("@mui/icons-material/FolderOpen"));
var _Home = _interopRequireDefault(require("@mui/icons-material/Home"));
var _NavigateNext = _interopRequireDefault(require("@mui/icons-material/NavigateNext"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* 
 * Renders an array of items as breadcrumbs
 */const hBreadcrumbBar = props => {
  const handleClick = id => {
    props.onBreadcrumbClick(id);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Breadcrumbs.default, {
    separator: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NavigateNext.default, {
      fontSize: "small"
    }),
    "aria-label": "breadcrumb",
    children: props.breadcrumbs.map((breadcrumb, key) => {
      const isFirstItem = key === 0;
      const isLastItem = key === props.breadcrumbs.length - 1;
      let breadcrumbIcon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Folder.default, {});
      if (isFirstItem) breadcrumbIcon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Home.default, {});else if (isLastItem) breadcrumbIcon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_FolderOpen.default, {});
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Breadcrumb.default, {
        icon: breadcrumbIcon,
        item: breadcrumb,
        onClick: handleClick
      }, key);
    })
  });
};
var _default = exports.default = hBreadcrumbBar;